import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { analyticService } from 'global/services';
import { useQuery, useReactiveVar } from '@apollo/client';
import { tp } from 'app/utils/typograf';

import { promocodeVar, selectedPeriodVar } from 'app/apollo/reaction';

import { normalizePhone, getDigitsFromPhone } from 'app/utils/phone';
import formatPrice from 'app/utils/price';
import { UIButton } from 'app/components/ui';

import TelephoneInput from 'app/components/Form/Telephone';
import { AuthContext } from 'app/containers/AuthContainer';
import pushLead from '../../../../../../../common/api/pushLead';
import BASKET_QUERY_CHECKOUT_PRICE from '../graphql/basketQueryCheckoutPrice.graphql';

import s from '../order-details-boxes.module.scss';
import { ConfigContext } from '../../../ConfigProvider';


const phoneValidationErrors = {
    incomplete: 'Укажите, пожалуйста, корректный номер телефона',
};

function cachePhoneValue(value) {
    const phoneValue = value.replace(/\D+/g, '');
    sessionStorage.setItem('phone', phoneValue);
}

export const isHalloweenPages = (pageId) => ['halloween', 'hlwn'].includes(pageId);
export const isRomanticPage = (pageId) => ['romantic'].includes(pageId);

const sendLead = async (phone) => {
    const pathNameSegment = window.location.pathname.slice(1, window.location.pathname.length - 1);

    function getValueFromUrl(key) {
        if (!window || !window.location) return '';

        const parsedUrl = new URL(window.location);
        const value = parsedUrl.searchParams.get(key);

        return value || '';
    }

    const options = {
        formName: pathNameSegment,
        phone: getDigitsFromPhone(phone),
        sourceSurvey: pathNameSegment,
        requestQuestion: pathNameSegment,
        referrerCode: getValueFromUrl('eeref'),
    };
    try {
        return await pushLead(options);
    } catch (e) {
        // ERROR
        // Raven.captureException(e);
        return e;
    }
};

export const BoxesCheckForm = ({ phoneValue, setInitialCheckoutPhone }) => {
    const promocode = useReactiveVar(promocodeVar);

    // promocodeVar

    const period = selectedPeriodVar();
    const { data: { cart } } = useQuery(BASKET_QUERY_CHECKOUT_PRICE, {
        variables: {
            period,
        },
    });
    const { userData } = useContext(AuthContext);
    const normalizedPhone = normalizePhone(phoneValue);
    const normalizedPhoneLength = 12;

    const {
        pageId,
    } = useContext(ConfigContext);

    const [phone, setPhone] = useState(normalizedPhone);
    const [phoneValidationError, setPhoneValidationError] = useState(null);
    const [isPhoneConfirmed, setIsPhoneConfirmed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleChangePhone = (e) => {
        const { target: { value } } = e;
        setPhone(value);
        setInitialCheckoutPhone(value);
    };

    const handleBlurPhone = async () => {
        const currentNormalizedPhone = normalizePhone(phone);
        if (currentNormalizedPhone.length < normalizedPhoneLength) {
            setIsPhoneConfirmed(false);
            setPhoneValidationError('incomplete');
            return;
        }

        cachePhoneValue(phoneValue);
        setIsPhoneConfirmed(true);
        setPhoneValidationError(null);

        const resp = await sendLead(phoneValue);
        const { data: { pushLead: leadData } } = resp;
        analyticService.push({
            eventName: 'Submit_Phone_Number',
            source: '5x2',
            userType: leadData.isNewbie ? 'new' : 'old',
        });
    };

    const handleSubmitPhone = async (e) => {
        e.preventDefault();

        if (normalizedPhone.length < normalizedPhoneLength) {
            setPhoneValidationError('incomplete');
            return;
        }

        setIsLoading(true);
        setPhoneValidationError(null);

        cachePhoneValue(phoneValue);

        const resp = await sendLead(phoneValue);
        const { data: { pushLead: leadData } } = resp;
        analyticService.push({
            eventName: 'Submit_Phone_Number',
            source: '5x2',
            userType: leadData.isNewbie ? 'new' : 'old',
        });

        const isHlwnPage = isHalloweenPages(pageId);
        const isEasterboxPage = pageId === 'easterbox';
        const paymentMethod = userData?.isLastSubscriptionHasRecurrent && !isEasterboxPage
            ? 'recurrent'
            : 'online';

        const hlwnCheckoutLink = `/checkout/?checkout_type=single&period=${period}${`&payment=online&promo_code=${promocode}`}`;
        const commonCheckoutLink = `/checkout/?period=${period}${`&payment=${paymentMethod}&promo_code=${promocode}`}`;

        const nextLocation = isHlwnPage ? hlwnCheckoutLink : commonCheckoutLink;

        if (isRomanticPage(pageId)) {
            sessionStorage.setItem('is_romantic_edit_disabled', 'true');
            const romanticCheckoutLink = `/checkout/?period=${period}${`&payment=${paymentMethod}&promo_code=${promocode}&hide=backstep.comment.edit_basket.payment_button_recurrent`}`;
            window.location = romanticCheckoutLink;
            return;
        }

        window.location = nextLocation;
    };
    const totalPrice = cart?.totals.total_price;
    const priceToBuy = cart?.totals.total_common_price;
    const isDiscountApplied = priceToBuy < totalPrice;

    useEffect(() => {
        if (isHalloweenPages(pageId)) {
            const btnNode = document.querySelector('#byBoxButton');
            const stBtnNode = document.querySelector('#openBoxSt');

            const hlwnParams = `?period=${period}&payment=online&checkout_type=single&&hide=backstep.comment.edit_basket.payment_button_recurrent&promo_code=${promocode}`;

            btnNode?.addEventListener('click', () => {
                window.location = `/checkout/${hlwnParams}`;
            });

            stBtnNode?.addEventListener('click', () => {
                window.location = '/basket/?dishes=4695&period=2026-10-26';
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageId, promocode]);

    return (
        <div className={s['boxes-phone-area']}>
            <div className="check-form-title">
                Оформить заказ
            </div>
            <div className={s['boxes-text-area']}>
                {tp.execute('Телефонный номер нужен для активации промокода на первый заказ. Заказ можно оформить и подтвердить онлайн без звонков.')}
            </div>
            <form className="order-form">
                <div className="phone-input-root">
                    <TelephoneInput
                        value={phone}
                        onChange={handleChangePhone}
                        onBlur={handleBlurPhone}
                        showMask
                        autoFocus={false}
                        isPhoneError={Boolean(phoneValidationError)}
                        isPhoneConfirmed={isPhoneConfirmed}
                    />
                </div>

                <UIButton
                    onClick={handleSubmitPhone}
                    aria-label="Оформить заказ"
                    loading={isLoading}
                    disabled={cart?.totals?.total_price === 0}
                >
                    <span className="title">Оформить заказ</span>
                    <span className="price">
                        <span className="num">{formatPrice(priceToBuy)}</span>
                        <span className="rub">₽</span>
                    </span>
                    {isDiscountApplied && (
                        <span className="original-price">
                            <span className="num">{formatPrice(totalPrice)}</span>
                            <span className="rub">₽</span>
                        </span>
                    )}
                </UIButton>
                {phoneValidationError && (
                    <div className="t-form__errorbox-middle">
                        <div className="js-errorbox-all t-form__errorbox-wrapper">
                            <div className="t-input__error-message t-input__error-message--static">
                                {phoneValidationErrors[phoneValidationError]}
                            </div>
                        </div>
                    </div>
                )}
            </form>
        </div>
    );
};

BoxesCheckForm.propTypes = {
    phoneValue: PropTypes.string.isRequired,
    setInitialCheckoutPhone: PropTypes.func.isRequired,
};
